import React from 'react'
import './inquiry-by-instrument.css'
const InquiryByInstrument = ({students}) => {
    const [instObj, setInstObj] = React.useState({})

    React.useEffect(() => {
        students.length > 0 && tallyAllStudentsByInstrument(students)
    }, [students])

    const tallyAllStudentsByInstrument = (students) => {
        let eachSchoolTotal = {
            MMA: { totalInstruments: {total: 0}, activeInstruments: {total: 0} },
            LSMA: { totalInstruments: {total: 0}, activeInstruments: {total: 0} },
            TMA: { totalInstruments: {total: 0}, activeInstruments: {total: 0} },
            MOR: { totalInstruments: {total: 0}, activeInstruments: {total: 0} },
            PSMA: { totalInstruments: {total: 0}, activeInstruments: {total: 0} }
        };
        for (let i = 0; i < students.length; i++) {
            if (students[i].school !== 'GLMA') {
                for (let j = 0; j < students[i].students.length; j++) {
                    const student = students[i].students[j];
                    const schoolTotal = eachSchoolTotal[students[i].school];
                    if (schoolTotal !== null) {
                        for (let k = 0; k < student.instrumentList.length; k++) {
                            const parentInstrument = student.instrumentList[k].parentInstrument;
                            if (parentInstrument) {
                                if (schoolTotal.totalInstruments[parentInstrument]) {
                                    schoolTotal.totalInstruments[parentInstrument] += 1;
                                    schoolTotal.totalInstruments['total'] ++
                                } else {
                                    schoolTotal.totalInstruments[parentInstrument] = 1;
                                    schoolTotal.totalInstruments['total'] ++
                                }
                            }
                            if (student.studentStatus === 'Active') {
                                if (schoolTotal.activeInstruments[parentInstrument]) {
                                    schoolTotal.activeInstruments[parentInstrument] += 1;
                                    schoolTotal.activeInstruments['total'] ++
                                } else {
                                    schoolTotal.activeInstruments[parentInstrument] = 1;
                                    schoolTotal.activeInstruments['total'] ++
                                }
                            }
                        }
                    }
                }
            }
        }

        //sort the totalInstruments by number of students and the activeInstruments by number of active students
        let sortable = [];
        for (let school in eachSchoolTotal) {
            let totalInstruments = eachSchoolTotal[school].totalInstruments;
            let activeInstruments = eachSchoolTotal[school].activeInstruments;
            sortable.push([school, totalInstruments, 'total']);
            sortable.push([school, activeInstruments, 'active']);
        }
        sortable.sort(function(a, b) {
            return b[1].total - a[1].total;
        });
        let sortedObj = {};
        for (let school in eachSchoolTotal) {
            sortedObj[school] = { totalInstruments: {}, activeInstruments: {} };
        
            let totalInstruments = eachSchoolTotal[school].totalInstruments;
            let activeInstruments = eachSchoolTotal[school].activeInstruments;
        
            // Sort totalInstruments by number of students
            let sortedTotalInstruments = Object.entries(totalInstruments)
                //.filter(([instrument]) => instrument !== 'total')
                .sort((a, b) => b[1] - a[1]);
            
            for (const [instrument, count] of sortedTotalInstruments) {
                sortedObj[school].totalInstruments[instrument] = count;
            }
        
            // Sort activeInstruments by number of active students
            let sortedActiveInstruments = Object.entries(activeInstruments)
                //.filter(([instrument]) => instrument !== 'total')
                .sort((a, b) => b[1] - a[1]);
        
            for (const [instrument, count] of sortedActiveInstruments) {
                sortedObj[school].activeInstruments[instrument] = count;
            }
        }
        eachSchoolTotal = sortedObj;
        setInstObj(eachSchoolTotal);
    };
    

    return (
        <div>
            {Object.keys(instObj).map((school, index) => (
                <div key={index} className='inquiry-by-instrument__each-school'>
                    <h3>{school}</h3>
                    <div className='inquiry-by-instrument__column'>
                        <h4>Total Instruments</h4>
                        {Object.keys(instObj[school].totalInstruments).map((instrument, index) => instrument !== 'total' && Math.round((instObj[school].totalInstruments[instrument] / instObj[school].totalInstruments['total']) * 100) > 3 && (
                            <div key={index}>
                                <p>{instrument}: {instObj[school].totalInstruments[instrument]} ({Math.round((instObj[school].totalInstruments[instrument] / instObj[school].totalInstruments['total']) * 100)}%)</p>
                            </div>
                        ))}
                    </div>
                    <div className='inquiry-by-instrument__column'>
                        <h4>Active Instruments</h4>
                        {Object.keys(instObj[school].activeInstruments).map((instrument, index) => instrument !== 'total' && Math.round((instObj[school].activeInstruments[instrument] / instObj[school].activeInstruments['total']) * 100) > 3 && (
                            <div key={index}>
                                <p>{instrument}: {instObj[school].activeInstruments[instrument]} ({Math.round((instObj[school].activeInstruments[instrument] / instObj[school].activeInstruments['total']) * 100)}%)</p>
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    )
}
export default InquiryByInstrument;